import React from 'react';
import { Typography, TextButton, ConfirmationModal } from 'seagull';
import { BulletList, SectionHelper, PointIndication } from "./components";
import styles from "./ImportingInvoicesToQBOModal.module.scss";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
//TODO - width and height shouldn't be fixed
export function ImportingInvoicesToQBOModal(props) {
  const {
    onClose,
    downloadCsv
  } = props;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testid": props['data-testid'],
    title: "Importing invoices to QBO",
    onCloseButtonClick: onClose,
    primaryButtonLabel: "Got it",
    onPrimaryButtonClick: onClose,
    width: "590px",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement(SectionHelper, {
      className: styles.section
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph2"
    }, "Your invoices CSV file is being downloaded.", ' ', /*#__PURE__*/React.createElement(TextButton, {
      skin: "secondary",
      size: "small",
      onClick: downloadCsv
    }, "Click here"), ' ', "if download doesn\u2019t start.")), /*#__PURE__*/React.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: styles.step
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      weight: "normal",
      as: "span"
    }, "Step 1:"), ' ', "Make sure your CSV is ready to upload to QBO"), /*#__PURE__*/React.createElement("div", {
      className: styles.indicatedText
    }, /*#__PURE__*/React.createElement(PointIndication, null), /*#__PURE__*/React.createElement(Typography, null, "Ensure that the \u201Cdisplay name\u201D fields on QBO and Anchor match. If required, you can modify it in Anchor or in the CSV."))), /*#__PURE__*/React.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: styles.step
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      weight: "normal",
      as: "span"
    }, "Step 2:"), ' ', "Upload your spreadsheet to QBO"), /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(Typography, null, "In QBO, go to", ' ', /*#__PURE__*/React.createElement(Typography, {
      weight: "normal",
      as: "span"
    }, "Settings"), ' ', "and select", ' ', /*#__PURE__*/React.createElement(Typography, {
      weight: "normal",
      as: "span"
    }, "Import data.")), /*#__PURE__*/React.createElement(Typography, null, "Select", ' ', /*#__PURE__*/React.createElement(Typography, {
      weight: "normal",
      as: "span"
    }, "Invoices.")), /*#__PURE__*/React.createElement(Typography, null, "Under the", ' ', /*#__PURE__*/React.createElement(Typography, {
      weight: "normal",
      as: "span"
    }, "Browse"), ' ', "button, select the checkboxes to add new customers that don\u2019t already exist in QuickBooks."), /*#__PURE__*/React.createElement(Typography, null, "Select", ' ', /*#__PURE__*/React.createElement(Typography, {
      weight: "normal",
      as: "span"
    }, "Browse"), ' ', "and select your invoices spreadsheet."), /*#__PURE__*/React.createElement(Typography, null, "Continue with QBO instructions."))), /*#__PURE__*/React.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/React.createElement(Typography, {
      skin: "secondary",
      variant: "paragraph2"
    }, "Need more help uploading multiple invoices?", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      size: "small",
      href: "https://quickbooks.intuit.com/learn-support/en-us/help-article/import-export-data-files/import-multiple-invoices/L7E9Xrd8l_US_en_US"
    }, "click here"))))
  });
}